import styled from 'styled-components';

const FullHeightFlex = styled.div`
  display: flex;
  flex-direction: column;
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`;

export default FullHeightFlex;
